/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: ShippersRoutingModule
 * Purpose		: Routing module for Shippers.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ShippersListComponent } from './ShippersList.component';
import { ShippersAddComponent }  from './ShippersAdd.component';
import { ShippersEditComponent } from './ShippersEdit.component';
import { ShippersDetailsComponent } from './ShippersDetails.component';

const ShippersRoutes: Routes = [
	{ path: 'Shippers',  component: ShippersListComponent },
	{ path: 'Shippers/add', component: ShippersAddComponent },
	{ path: 'Shippers/:id', component: ShippersEditComponent },
	{ path: 'Shippers/Details/:id', component: ShippersDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(ShippersRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class ShippersRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Shippers/Shippers-routing.module.ts